<app-modal [title]="title" (closed)="closed.emit()">
  @if (options) {
    <div class="z-glass z-glass--inset hm-plot">
      <app-chart [options]="options" [height]="360" />
    </div>
  }
</app-modal>
